import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/service/src/environments/environment';

const BASE_URL = environment.masterApiURL;

@Injectable({
  providedIn: 'root'
})
export class MasterItemcodePopupService {

  constructor(private http: HttpClient) { }

  
  public rolePermissions: any = {}

  getServiceItems() {
    return this.http.get(`${BASE_URL}ServiceItem/GetServiceItems`);
  }

  updateChannel(data: any) {
    return this.http.post(`${BASE_URL}ServiceItem/UpdateChannel`, data);
  }

  getItemDetailsById(item: any) {
    return this.http.get(`${BASE_URL}ServiceItem/GetById?item=${item}`);
  }
  
  getAccountsByItem(item:any){
    return this.http.get(`${BASE_URL}ServiceItem/GetAccountByItem?item=${item}`);
  }

  uploadImage(image: any) {
    return this.http.post(`${BASE_URL}FileManagement/UploadTemp`,image);
  }

  enableDisableStatus(item: string, status: 'inactive' | 'active') {
    return this.http.post(`${BASE_URL}ServiceItem/UpdateServiceItemStatus?item=${item}&status=${status}`, {});
  }
  save(data: any) {
    return this.http.post(`${BASE_URL}ServiceItem/Update`, data);
  }

  

  getAccountsBasedOnChannel(channel: any) {
    return this.http.get(`${BASE_URL}Common/GetAccountsDDLForChannel?channel=${channel}`);
  }

  
  getAllChannels(moduleName:string) {
    return this.http.get(`${BASE_URL}Common/GetAllChannels?moduleName=${moduleName}`);
  }
  getRolePermission(category: any = '', subCategory: string = '', module: string = '', id: string = '') {
    return this.http.get(`${BASE_URL}RolePermission/Get?category=${category}&subCategory=${subCategory}&id=${id}&module=${module}`);
  }
}


